module.exports = __webpack_public_path__ + "static/media/sort-size-up-alt.b5e1cc04.svg";